import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { Layout } from 'shared/ui/Layout';
import { Header } from 'widgets/Header';
import { Sidebar } from 'widgets/Sidebar';
import { Footer } from 'widgets/Footer';
export var MainLayout = function () { return (_jsx(Layout, { sidebarSlot: _jsx(Sidebar, {}), headerSlot: _jsx(Header, {}), pageSlot: _jsx(Outlet, {}), footerSlot: _jsx(Footer, {}) })); };
